(ns app.front.view.property.dashboard.widgets.filters
  (:require [app.domain.property.model :as property-model]
            [app.front.ui.filter-boxes :as ui-fb]
            [app.front.ui.select :as ui-select]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-db ::add-attribute-filter
  (fn [db [_ attribute]]
    (update db ::attribute-filters #(conj (or % []) {:template-id attribute
                                                     :value       nil}))))


(defn remove-nth [v n]
  (vec (concat (subvec v 0 n) (subvec v (inc n)))))


(rf/reg-event-fx ::remove-attribute-filter
  (fn [{:keys [db]} [_ idx on-change-fx]]
    {:db (update db ::attribute-filters #(remove-nth % idx))
     :fx [[:dispatch on-change-fx]]}))


(rf/reg-event-fx ::reset-attribute-filters
  (fn [{:keys [db]} [_ on-change-fx]]
    (merge {:db (dissoc db ::attribute-filters)}
           (when on-change-fx
             {:fx [[:dispatch on-change-fx]]}))))


(rf/reg-event-fx ::set-attribute-filter-value
  (fn [{:keys [db]} [_ idx value on-change-fx debounce?]]
    (merge {:db (update db ::attribute-filters #(assoc-in (or % []) [idx :value] value))}
           (if debounce?
             {:dispatch-debounce [{:id      ::attribute-filter-changed
                                   :timeout 500
                                   :action  :dispatch
                                   :event   on-change-fx}]}
             {:fx [[:dispatch on-change-fx]]}))))


(rf/reg-sub ::attribute-filters
  :-> ::attribute-filters)


(def free-input-types #{:property-attribute-template.type/integer
                        :property-attribute-template.type/decimal
                        :property-attribute-template.type/text})


(defn attribute-select
  "Select for adding a filter on a property attribute. `:light?` is for a gray background and
   `:class-name` is passed on to the select, e.g. to make it fill its container."
  [tr attributes {:keys [light? class-name]}]
  (let [filtered-ids (->> (<sub [::attribute-filters]) (map :template-id) set)]
    [ui-select/select (p/assoc-if {:id              "attribute-filter-select"
                                   :label-text      (tr [:property-filters/attributes])
                                   :hide-label      true
                                   :allow-empty?    false
                                   :select-text     (tr [:property-filters/attributes])
                                   :values          (->> attributes
                                                         (remove #(contains? filtered-ids (:db/id %)))
                                                         (sort-by :ordered/order))
                                   :on-change       #(>evt [::add-attribute-filter (:db/id %)])
                                   :value           nil
                                   :light           (boolean light?)
                                   :val->str        property-model/attribute-template-name
                                   ;; nil is the "Attributes" prompt, not a selectable attribute.
                                   :disabled-values #{nil}}
                                  :class-name      class-name)]))

(defn attribute-filter-boxes
  "Boxes for editing and removing the selected property attribute filters."
  [tr attributes on-change-fx]
  (let [lang (<sub [:language])]
    [ui-fb/filter-boxes tr (->> (<sub [::attribute-filters])
                                (map-indexed
                                  (fn [idx {:keys [template-id value]}]
                                    (let [template      (-> attributes
                                                            (p/find-first #(= template-id (:db/id %))))
                                          template-type (-> template :property-attribute-template/type)
                                          free-input?   (free-input-types template-type)
                                          val->str      #(some-> %
                                                                 :property-attribute-template-option/values
                                                                 (i18n-model/get-text-from-entities-or-map lang))]
                                      {:id        (str "filter-box-" idx)
                                       :title     (property-model/attribute-template-name template)
                                       :type      (-> template-type name keyword)
                                       :values    (->> template
                                                       :property-attribute-template/options
                                                       (sort-by :ordered/order)
                                                       (map val->str))
                                       :value     value
                                       :on-change (fn [val]
                                                    (let [event-v [::set-attribute-filter-value
                                                                   idx
                                                                   val
                                                                   on-change-fx
                                                                   free-input?]]
                                                      (if free-input?
                                                        (rf/dispatch-sync event-v)
                                                        (rf/dispatch event-v))))
                                       :on-remove #(>evt [::remove-attribute-filter idx on-change-fx])}))))]))

(defn filters [tr attributes on-change-fx opts]
  [:div.flex.gap-4.mt-4.flex-col
   [attribute-select tr attributes opts]
   [attribute-filter-boxes tr attributes on-change-fx]])
